<template>
    <div class="col-lg-6 col-xl-4">
        <div class="sticky-top pt-5 creator-left">
            <h1 class="h4">
                <strong>{{ $t("Matricatervező") }}</strong>
            </h1>
            <div class="form-floating mb-2">
                <select
                    class="form-select"
                    id="sticker_size"
                    data-currency="Ft"
                    v-model="selectedSku"
                >
                    <option
                        v-for="(item, index) in stickers"
                        v-bind:key="'sticker-' + index"
                        :value="item.sku"
                        :data-price-textile="item.price_textile"
                        :data-price-plastic="item.price_plastic"
                        >{{ item.name }}</option
                    >
                </select>
                <label for="sticker_size">{{
                    $t("Válassz matrica típust")
                }}</label>
            </div>
            <div class="preview-holder my-4" ref="holder">
                <StickerSvg
                    id="preview"
                    :maxHeight="300"
                    :sticker="sticker"
                    :design="model"
                    :figureHref="figureHref"
                    :backgroundHref="backgroundHref"
                />
            </div>
            <div
                class="preview-floating"
                v-if="floating"
                aria-hidden="true"
                v-on:click="scrollToPreview"
            >
                <StickerSvg
                    :sticker="sticker"
                    :design="model"
                    :figureHref="figureHref"
                    :backgroundHref="backgroundHref"
                />
            </div>
            <div
                class="white-box"
                v-if="hasFigureOption || hasBackgroundOption"
            >
                <div
                    class="form-check form-switch form-control-lg py-0"
                    v-if="hasFigureOption"
                >
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="switchFigure"
                        :checked="model.allowedFigure"
                        v-on:change="
                            $emit('update', {
                                allowedFigure: $event.target.checked
                            })
                        "
                    />
                    <label
                        class="form-check-label form-control-sm"
                        for="switchFigure"
                        >{{ $t("Minta") }}</label
                    >
                </div>
                <div
                    class="form-check form-switch form-control-lg py-0"
                    v-if="hasBackgroundOption"
                >
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="switchBg"
                        :checked="model.allowedBackground"
                        v-on:change="toggleBackground($event.target.checked)"
                    />
                    <label
                        class="form-check-label form-control-sm"
                        for="switchBg"
                        >{{ $t("Háttér") }}</label
                    >
                </div>
                <div
                    class="side-switch mt-2"
                    v-if="hasFigureOption && model.allowedFigure"
                    role="group"
                    :aria-label="$t('Minta helye')"
                >
                    <span class="form-control-sm ps-0">{{
                        $t("Minta helye")
                    }}</span>
                    <button
                        type="button"
                        class="btn btn-sm"
                        :class="
                            isRightSide
                                ? 'btn-outline-secondary'
                                : 'btn-primary'
                        "
                        :aria-pressed="!isRightSide"
                        v-on:click="$emit('update', { selectedSide: 0 })"
                    >
                        {{ $t("Bal") }}
                    </button>
                    <button
                        type="button"
                        class="btn btn-sm"
                        :class="
                            isRightSide
                                ? 'btn-primary'
                                : 'btn-outline-secondary'
                        "
                        :aria-pressed="isRightSide"
                        v-on:click="$emit('update', { selectedSide: 1 })"
                    >
                        {{ $t("Jobb") }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import StickerSvg from "../sticker/StickerSvg";

const MOBILE_BREAKPOINT = 768;

export default {
    name: "LeftSide",
    components: { StickerSvg },
    props: ["stickers", "sticker", "model", "figureHref", "backgroundHref"],
    data() {
        return {
            holderVisible: true,
            isMobile: false,
            observer: null
        };
    },
    computed: {
        selectedSku: {
            get() {
                return this.model.sticker;
            },
            set(sku) {
                this.$emit("selectSticker", sku);
            }
        },
        hasFigureOption() {
            return parseInt(this.sticker.figure) === 1;
        },
        hasBackgroundOption() {
            return parseInt(this.sticker.background) === 1;
        },
        isRightSide() {
            return parseInt(this.model.selectedSide) === 1;
        },
        floating() {
            return this.isMobile && !this.holderVisible;
        }
    },
    mounted() {
        this.onResize();
        window.addEventListener("resize", this.onResize);
        if ("IntersectionObserver" in window) {
            // Float only once the preview has scrolled above the screen,
            // not while it is still further down the page.
            this.observer = new IntersectionObserver(entries => {
                const entry = entries[0];
                this.holderVisible =
                    entry.isIntersecting || entry.boundingClientRect.top > 0;
            });
            this.observer.observe(this.$refs.holder);
        }
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
        if (this.observer) {
            this.observer.disconnect();
        }
    },
    methods: {
        onResize() {
            this.isMobile = window.innerWidth < MOBILE_BREAKPOINT;
        },
        // Switches only show / hide; the chosen artwork is kept for switching back on.
        toggleBackground(checked) {
            this.$emit("update", { allowedBackground: checked });
        },
        scrollToPreview() {
            this.$refs.holder.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
        }
    }
};
</script>

<style scoped></style>
